import { render, staticRenderFns } from "./TagCellRenderer.vue?vue&type=template&id=18f04893"
import script from "./TagCellRenderer.vue?vue&type=script&lang=js"
export * from "./TagCellRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports